var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { selectView } from '../../Redux/selectors/selectors';
import styles from './FeatureModal.module.scss';
import LoadingArea from '../../Loaders/LoadingArea';
import '../../index.css';
import SubTitle from '../UI/SubTitles/SubTitle';
export var FeatureModal = function (_a) {
    var isModalOpen = _a.isModalOpen, handleCancel = _a.handleCancel;
    var howItWorksData = useSelector(selectView).howItWorksData;
    return (_jsx(Modal, __assign({ width: 932, title: _jsx(SubTitle, { text: 'About this feature', level: 7 }), open: isModalOpen, onCancel: handleCancel, closable: false, footer: null, className: 'newModalStyles' }, { children: !howItWorksData ? (_jsx("div", __assign({ className: styles.loaderContainer }, { children: _jsx("div", __assign({ className: styles.loaderWrapper }, { children: _jsx(LoadingArea, { isTableLoader: false }) })) }))) : (_jsx("div", { dangerouslySetInnerHTML: { __html: howItWorksData === null || howItWorksData === void 0 ? void 0 : howItWorksData.description } })) })));
};
